import { InjectionToken, Injector, Type } from '@angular/core';
import type { FormFieldEntry } from '../helpers/form-config';
import { ModulesEnum } from '../enums/modules.enum';
import { ManageModuleStore } from '../interfaces/shared/manage-module-store.interface';
import { ModuleAction } from '../interfaces/shared/module-action.interface';
import { ModuleDescriptor } from '../interfaces/shared/module-descriptor.interface';
import { ModuleLink } from '../interfaces/shared/module-link.interface';

export const MODULE_DESCRIPTOR = new InjectionToken<
  ModuleDescriptor<unknown, unknown>
>('ModuleDescriptor');

/** Cross-module record nav links for the active manage module; provide per route when used (see manage app routes). */
export const MODULE_LINKS = new InjectionToken<ModuleLink[]>(
  'ModuleLinks',
);

/** Record menu actions for the active manage module; provide per route (see manage app routes). */
export const MODULE_ACTIONS = new InjectionToken<ModuleAction[]>(
  'ModuleActions',
);
export const MODULE_STORE = new InjectionToken<ManageModuleStore>(
  'ModuleStore',
);

/** Form field list for the active module’s record screen; provide per module route (see manage app routes). */
export const MODULE_FORM_CONFIG = new InjectionToken<readonly FormFieldEntry[]>(
  'ModuleFormConfig',
);

/** When a list/record is opened from another record (e.g. links nav), the host manage module. */
export const EMBED_PARENT_MODULE = new InjectionToken<ModulesEnum>(
  'EMBED_PARENT_MODULE',
);

/** Merged onto the child module’s new record when using Add from an embedded links-nav list. */
export const EMBED_NEW_RECORD_OVERLAY = new InjectionToken<
  Record<string, unknown> | undefined
>('EMBED_NEW_RECORD_OVERLAY');

/** Host record id when embedded from another record (e.g. customer id when opening rentals list). */
export const EMBED_PARENT_RECORD_ID = new InjectionToken<number>(
  'EMBED_PARENT_RECORD_ID',
);

export interface NestedRecordTitle {
  component: Type<unknown>;
  injector: Injector;
}

/** Nearest ancestor record context for a nested-area back-button title. */
export const NESTED_RECORD_TITLE = new InjectionToken<NestedRecordTitle | null>(
  'NESTED_RECORD_TITLE',
);
